import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

const updateItems = async ({ updates }) => {
  console.log('[UpdateItems] called with updates: ', updates)
  const url = `${baseUrl}/aws/updateitems`
  try {
    const response = await axios.put(url, { updates })
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to update items:', error)
    throw error
  }
}

export const useUpdateItems = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: updateItems,
    onSuccess: (data, variables) => {
      console.log('[useUpdateItems] Updated items data:', data, 'VARIABLES: ', variables)
    },
    onError: error => {
      console.error('[useUpdateItems] Error updating items:', error)
    },
  })

  return mutation
}
